import { styled } from '@mui/material';

export const Wrap = styled('div')({
	width: '100%',
	height: '100%',
	flex: 1,
});

export const AsyncWrap = styled('div')({
	width: '100%',
	height: '40px',
	marginBlock: '16px',
});
